import { connect } from "dva";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import "../TaskDetailEditDraw/index.less"; // TODO: 这里编辑和新建使用一套css文件，后续考虑把新建和编辑合并，都使用编辑的页面来做
import { Button, Drawer, Input, message, Modal, Select, Collapse, Switch, Tooltip } from "antd";
import { nanoid } from "nanoid";
import IconFont from "@/components/icon";
import DatePicker from "@/components/Calendars/BaseComponents/DatePicker";
import TypeSelect from "../BaseComponents/TypeSelect";
import { findIndexExecutorInTask } from "../utils";
import { NewTaskModel, PRIORITY_TYPE, WorkUserInfo } from "@/types/newWork";
import GlobalContext from "@/context/GlobalContext";
import bus from "@/utils/bus";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import prompt from "@/baseComponents/ModalComponent/prompt";
import { TaskResourceBizType, TaskResourcePermissionType, GroupMessagePart } from "@/types/work";
import DeeplinkEvent, { DeeplinkPathEnum } from "@/components/DeeplinkHandler/DeeplinkEvent";
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { createTask } from "@/api/work";
import { decorateQuickCreateTaskResource } from "../newUtils";
import { ChatMessageBody, Employee } from "@/types/chat";
import lodashCompact from "lodash/compact";
import { shareScheduleAttachment } from "@/api/calendar";

export enum FileStatus {
  Init = 1,
  Uploading,
  Done,
  failed
}
import syncConfirm from "@/utils/syncConfirm";
import { getEBookUserDetail } from "@/api/ebook";
const { Panel } = Collapse;
const { Option } = Select;
export const remindList = [
  {
    value: "0",
    label: "不提醒"
  },
  {
    value: "-0",
    label: "任务截止时"
  },
  {
    value: "-5",
    label: "截止前5分钟"
  },
  {
    value: "-10",
    label: "截止前10分钟"
  },
  {
    value: "-15",
    label: "截止前15分钟"
  },
  {
    value: "-30",
    label: "截止前30分钟"
  },
  {
    value: "-60",
    label: "截止前1小时"
  },
  {
    value: `-${60 * 2}`,
    label: "截止前2小时"
  },
  {
    value: `-${60 * 24}`,
    label: "截止前1天"
  },
  {
    value: `-${60 * 24 * 2}`,
    label: "截止前2天"
  }
];
import ScrollView from "@/baseComponents/ScrollView";
import config, { ConfigEnum } from "@/config/config";
import AttachmentItem from "@/components/AttachmentComp/attachmentItem";
import { ContactShowType } from "@jd/focus-desktop-comps/lib/es/UserSelection/types";
import { userSelectionBusinessTabSort, userSelectionTabSort } from "@/types/common";
import TaskGroupModal from "../BaseComponents/TaskGroupModal";
import { isBoolean } from "lodash";
import { MemberKeys } from "@/models/work";
import UserStatusListPopover from "@/baseComponents/UserStatusListPopover";
import UserListMore, { UserItem } from "@/baseComponents/UserListMore";
import { BusinessForm } from "@/utils/chat/message";

const initTaskDetail: NewTaskModel = {
  title: "",
  taskGroupIds: [],
  taskId: nanoid(),
  owner: {
    userId: "",
    teamId: "",
    app: "",
    headImg: "",
    realName: "",
    processStatus: 1
  },
  executors: [],
  subscribers: [],
  remind: "0",
  priorityType: PRIORITY_TYPE.NORMAL_PRIORITY,
  workStartTime: null,
  workStopTime: null,
  startTime: -1,
  endTime: -1,
  content: "",
  remark: {
    id: "",
    remark: ""
  },
  resources: [],
  processAuditFlag: 0
};

let clicksign = false; // 记录是不是点击 label里的 ‘+ 添加附件’
// eslint-disable-next-line complexity
function CreateTaskDraw({
  userData,
  isMessageModule,
  taskGroupList,
  groupId,
  activeKey,
  currentEmployee,
  fetchTaskGroupsList
}: {
  userData: any;
  isMessageModule: boolean;
  taskGroupList: any[];
  groupId: string;
  activeKey: string;
  currentEmployee: any;
  fetchTaskGroupsList: () => void;
}) {
  const { t } = useTranslation("work");
  const [t_common] = useTranslation("common");
  const [t_chat] = useTranslation("chat");
  const [drawVisible, setDrawVisible] = useState<boolean>(false);
  const [taskDetail, setTaskDetail] = useState<NewTaskModel>(initTaskDetail);
  const [fileList, setFileList] = useState<any[]>([]);
  const [textareaContentFocus, setTextareaContentFocus] = useState<boolean>(false);
  const [moreVisible, setMoreVisible] = useState(true);
  const [textareaTitleFocus, setTextareaTitleFocus] = useState<boolean>(false);
  const [selectedSession, setSelectedSession] = useState<any>(null);
  const [submitting, setSubmitting] = useState(false);
  const { authInfo, imService } = useContext(GlobalContext);
  const [remindArr, setRemindArr] = useState<string[]>([]);
  const taskGroupDeleted = useRef(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const resetData = useCallback(() => {
    setDrawVisible(false);
    setTaskDetail(initTaskDetail);
    setFileList([]);
    setRemindArr([]);
    setMoreVisible(true);
  }, []);

  const closeDrawConfirm = useCallback(() => {
    function cancleAtt(status: boolean) {
      bus.off("cancle-attachment-upload", cancleAtt);
      // if (status) {
      //     message.warning(t('attachment uploading'));
      //     return;
      // } else {
      try {
        // 判断是否有编辑内容
        if (JSON.stringify(initTaskDetail) !== JSON.stringify(taskDetail) || status) {
          Modal.confirm({
            content: <span className="nimble-con">{t("tip content")}</span>,
            transitionName: "notransition",
            maskTransitionName: "notransition",
            okText: t("confirm"),
            cancelText: t("cancel"),
            onOk() {
              resetData();
              status && bus.emit("close-modal-with-cancle-attachment-upload");
              // document
              //     .getElementsByClassName('ant-modal-root')[0]
              //     ?.setAttribute('id', 'confirmmodal');
              // const ele = document.getElementById('confirmmodal');
              // if (ele) ele.style.display = 'none';
            }
          });
        } else {
          resetData();
        }
      } catch (error) {
        resetData();
      }
      // }
    }
    bus.on("cancle-attachment-upload", cancleAtt);

    bus.emit("close-modal-detail");

    return () => {
      bus.off("cancle-attachment-upload", cancleAtt);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetData, t, taskDetail]);
  const scrollRef = useRef(null);

  const handleOpenCreateDrawVisible = useCallback(
    async (data: any) => {
      let currUser: any;
      try {
        currUser = await getEBookUserDetail({
          userId: authInfo.userId,
          teamId: authInfo.teamUserInfo.teamId,
          appId: authInfo.ddAppId
        });
      } catch (err) {
        message.error((err as any).message || "网络异常");
        return;
      }

      const titleName = currUser.fields.find((item: any) => item.key === "e_position")?.val || "";
      const curAuthInfo = {
        userId: authInfo.userId,
        teamId: authInfo.teamUserInfo.teamId,
        app: authInfo.ddAppId,
        processStatus: data.processStatus,
        headImg: authInfo.teamUserInfo.headImg || "",
        realName: authInfo.teamUserInfo.realName || authInfo.account,
        deptName: authInfo.teamUserInfo.teamShortName,
        titleName
      };
      setSelectedSession(data.selectedSession ? data.selectedSession : null);
      const resource = data.messageResource;
      const resourceArr = data.messageResourceArr;
      // 消息图片文件转任务
      const initResource = resourceArr
        ? resourceArr.map((r: any) => decorateQuickCreateTaskResource(r))
        : resource
        ? [decorateQuickCreateTaskResource(resource)]
        : null;
      setFileList(initResource ? initResource : []);
      setDrawVisible(true);
      isBoolean(data.moreVisible) ? setMoreVisible(data.moreVisible) : setMoreVisible(true);
      initTaskDetail.owner = { ...curAuthInfo };

      // 组通知转任务
      let _executors: any[] = [];
      if (data.groupNoticeReadingMemberList) {
        _executors = data.groupNoticeReadingMemberList.map((v: any) => {
          return {
            userId: v.userId,
            teamId: v.teamId,
            app: v.appId,
            processStatus: v.processStatus,
            headImg: v.headImg || "",
            realName: v.realName,
            deptName: v.labelInfoList.find((o: any) => o.label === "dept")?.name,
            titleName: v.labelInfoList.find((o: any) => o.label === "title")?.name
          };
        });
        // if (!_executors.find((v: any) => v.userId === authInfo.userId)) {
        //   _executors.unshift(curAuthInfo);
        // }
      }

      initTaskDetail.executors = _executors.map((v: any) => ({
        weight: 5,
        ...v
      }));
      if (data.workStopTime && remindArr.length === 0) {
        let arr = ["-0", "-60", `-${60 * 24}`];
        setRemindArr(arr);
        initTaskDetail.remind = arr.join(",");
      }
      setTaskDetail((task) => {
        return {
          ...task,
          title: data.title?.length > 100 ? data.title.substr(0, 100) : data.title || "",
          resources: initResource ? initResource : [],
          owner: { ...curAuthInfo },
          executors: _executors.map((v: any) => ({
            weight: 5,
            ...v
          })),
          content: data.content || "",
          workStopTime: data.workStopTime || null,
          endTime: data.workStopTime ? data.endTime : null,
          taskGroupIds: (taskGroupList || [])
            .filter((v) => v.groupStatus !== 2 && v.groupId === groupId)
            .map((g) => g.groupId)
        };
      });
    },
    [
      authInfo?.account,
      authInfo?.ddAppId,
      authInfo?.teamUserInfo?.headImg,
      authInfo?.teamUserInfo?.realName,
      authInfo?.teamUserInfo?.teamId,
      authInfo?.teamUserInfo?.teamShortName,
      authInfo?.userId,
      groupId,
      remindArr?.length,
      taskGroupList
    ]
  );

  useEffect(() => {
    const resetGroupId = (data: any) => {
      if (!drawVisible) {
        return;
      }
      if (
        data.part === GroupMessagePart.TASK_GROUP_REMOVE ||
        data.part === GroupMessagePart.TASK_GROUP_REMOVE_USER
      ) {
        message.info({
          content: "任务分组权限发生变更",
          key: "task-group-permission-changed"
        });
        setTaskDetail((prev) => ({
          ...prev,
          taskGroupIds: prev.taskGroupIds?.filter((i) => i !== data.taskGroupId)
        }));
      }
    };
    // 分组数据更新，重置已选择的分组
    bus.on("joywork:refresh-group", resetGroupId);

    return () => {
      bus.off("joywork:refresh-group", resetGroupId);
    };
  }, [drawVisible]);

  // 初始化数据
  useEffect(() => {
    bus.on("task:open-create", handleOpenCreateDrawVisible);
    return () => {
      bus.off("task:open-create", handleOpenCreateDrawVisible);
    };
  }, [authInfo, groupId, handleOpenCreateDrawVisible, remindArr, taskDetail, taskGroupList]);

  async function handleInputChange(e: any, key: string, notInput?: boolean) {
    let value = notInput ? e : e.target.value;
    // if (!value) return;
    // 多行文本输入的时候，如果是拼音，输入的时候，不按空格或选择，点击空白，拼音会上屏，这里只有备注和任务描述是textarea
    if (value?.length > 500) {
      value = value.slice(0, 500);
    }
    if (key === "remark") {
      value = {
        id: taskDetail.remark.id,
        remark: e.target.value ? e.target.value : ""
      };
    }
    const task = {
      ...taskDetail,
      [`${key}`]: value ? value : ""
    };
    setTaskDetail(task);
  }
  const handleUpdateOwner = useCallback(() => {
    const { userId, teamUserInfo } = userData;
    const { ddAppId, teamId } = teamUserInfo;
    const isGroup = selectedSession?.["isGroup"];
    const sessionId = selectedSession?.["sessionId"];
    let tabs = ["recent", "org", "workLine", "externalContacts", "group"];
    if (!config[ConfigEnum.EXTERNAL_CONTACTS_ORG]) {
      tabs = ["recent", "workLine", "externalContacts", "group"];
    }
    let tabSort = userSelectionTabSort;
    if (isGroup) {
      tabs.unshift("business");
      tabSort = userSelectionBusinessTabSort;
    }
    openUserSelectionDefaultModal(
      {
        title: t_chat("add_member"),
        tabs: JSON.parse(JSON.stringify(tabs)),
        tabSort: tabSort,
        // tabs: isGroup
        //     ? ['recent', 'org', 'group', 'externalContacts', 'business']
        //     : ['recent', 'org', 'group', 'externalContacts'],
        single: true,
        recommendParam: {
          keyWords: taskDetail.title || "",
          aiType: ["empl"]
        },
        contactShowType: ContactShowType.sameTenement,
        // contactsFilterFlag: ["crossPlatform", "sameTeam", "crossTeam"],
        currentUser: {
          app: ddAppId,
          pin: userId,
          teamId: teamId
        },
        businessTab: {
          tabName: "当前群成员",
          tabParam: {
            businessType: isGroup ? "group" : "project",
            businessId: isGroup ? (sessionId ? sessionId : "") : ""
          }
        },

        resultUsers: lodashCompact([taskDetail.owner]).map((item: any) => ({
          id: item.userId + ":" + item.app + ":" + item.teamId,
          name: item.realName,
          avatar: item.headImg,
          userId: item.userId,
          teamId: item.teamId,
          checked: true,
          visible: true
        }))
      },
      (data, close) => {
        // 过滤掉已选中的
        const { result } = data.data;
        if (!result.length) {
          return close();
        }
        const addArr: any[] = [];
        result.forEach((r: any) => {
          if (r.id) {
            const strs = r.id.split(":");
            return addArr.push({
              userId: strs[0],
              teamId: strs[2],
              app: strs[1],
              headImg: r.avatar,
              realName: r.name
            });
          }
          const { origin } = r;
          if (origin.info) {
            addArr.push({
              userId: origin.info.userId,
              teamId: origin.info.teamId,
              app: origin.info.appId || origin.info.app,
              headImg: origin.info.headImg,
              realName: origin.info.realName
            });
          } else {
            addArr.push({
              userId: origin.userId,
              teamId: origin.teamId,
              app: origin.app,
              headImg: origin.headImg,
              realName: origin.realName
            });
          }
        });
        prompt({
          title: t(
            `${!taskDetail.owner ? "Set the person in charge" : "Person in charge of update"}`
          ),
          icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
          onOk: async () => {
            setTaskDetail((task: any) => {
              return { ...task, owner: addArr[0] };
            });
          },
          content: t("update owner desc").replace("%s", addArr[0].realName),
          okText: t_common("button.ok"),
          cancelText: t_common("button.cancel")
        });

        close();
      },
      userData
    );
  }, [t, t_chat, t_common, selectedSession, taskDetail, userData]);

  const onVisibleChange = (visable: boolean) => {
    if (visable) {
      // 显示的时候，高低太低会使时间选择框错位，手动向下滚动一下
      const detailElement: HTMLElement | null = document.querySelector(".detail-content");
      if (detailElement && detailElement.offsetHeight + detailElement.scrollTop < 710) {
        detailElement.scrollTo(0, 710 - detailElement.offsetHeight);
      }
    }
  };

  async function handleAddTaskMembers(key: MemberKeys, data: any[]) {
    const temp: any[] = [];
    const members = [...taskDetail[key]];
    data.forEach((m: any) => {
      const index = findIndexExecutorInTask(members, m);
      if (index === -1) {
        temp.push(m);
      } else {
        members[index] = { ...members[index], ...m };
      }
    });
    if (temp.length === 0) {
      return;
    }
    if ([...members, ...temp]?.length > 200) {
      message.warn(t("200 person limit"));
      return;
    }
    setTaskDetail((task: any) => {
      return { ...task, [key]: [...members, ...temp] };
    });
  }
  async function handledelMember(key: MemberKeys, data: any[]) {
    const members = [...taskDetail[key]];
    data.forEach((m) => {
      const index = findIndexExecutorInTask(members, m);
      if (index > -1) {
        members.splice(index, 1);
      }
    });
    const newTaskDetail = { ...taskDetail, [key]: members };
    setTaskDetail(newTaskDetail);
  }
  // eslint-disable-next-line complexity
  async function handleTimeChange(time: Dayjs | null, start = true) {
    const unix = time ? time.valueOf() : null;
    if (start) {
      if (!unix || unix === taskDetail.startTime) {
        return;
      }
      let timeObj: any = {
        startTime: unix,
        workStartTime: dayjs(unix)
      };
      if (
        taskDetail.workStopTime &&
        dayjs(unix)?.add(30, "minute").isAfter(taskDetail.workStopTime)
      ) {
        timeObj = {
          ...timeObj,
          endTime: dayjs(unix)?.add(30, "minute").valueOf(),
          workStopTime: dayjs(unix)?.add(30, "minute")
        };
      }
      setTaskDetail({
        ...taskDetail,
        ...timeObj
      });
    } else {
      if (!unix || unix === taskDetail.endTime) {
        if (!unix) {
          setRemindArr([]);
        }
        return;
      }
      if (
        taskDetail.workStopTime &&
        taskDetail.workStartTime &&
        dayjs(unix).isBefore(taskDetail.workStartTime.add(30, "minute"), "minute")
      ) {
        return message.warn(t("deadline is at least 30 minutes later than the start time"));
      }
      const etime: Dayjs =
        !taskDetail.workStopTime &&
        taskDetail.workStartTime &&
        dayjs(unix).isBefore(taskDetail.workStartTime.add(30, "minute"), "minute")
          ? taskDetail.workStartTime.add(30, "minute")
          : dayjs(unix);
      const task = {
        ...taskDetail,
        endTime: etime.valueOf(),
        workStopTime: etime
      };
      if (!start && time && remindArr.length === 0) {
        let arr = ["-0", "-60", `-${60 * 24}`];
        setRemindArr(arr);
        task.remind = arr.join(",");
      }
      setTaskDetail(task);
    }
  }
  async function handlePriorityChange(priority: number) {
    if (taskDetail.priorityType === priority) {
      return;
    }
    const task = { ...taskDetail, priorityType: priority };
    setTaskDetail(task);
  }

  function onAttachmentRemove(fileId: string) {
    if (!taskDetail) {
      return;
    }
    const index = taskDetail.resources.findIndex((item) => item.bizId === fileId);
    if (index < -1) {
      return;
    }
    const temp = taskDetail.resources.map((item) => {
      return {
        ...item,
        fileName: item.name,
        fileId: item.bizId || nanoid(20),
        fileUrl: item.url,
        status: FileStatus.Done
      };
    });
    temp.splice(index, 1);

    setFileList(temp as any);
    setTaskDetail({ ...taskDetail, resources: temp });
  }
  async function onAttachmentUploadFinish(file: any) {
    if (Array.isArray(file)) {
      const files = file;
      let newArr = files.map((f) => {
        return {
          ...f,
          name: f.fileName,
          size: f.size,
          url: f.fileUrl,
          resourceId: nanoid(),
          bizId: f.fileId,
          bizType: f.bizType || TaskResourceBizType.FILE,
          resourceType: TaskResourcePermissionType.COMMON,
          fileType: f.fileType,
          creatorUserId: f?.creatorUserId
        };
      });
      const resources = taskDetail.resources;
      resources.push(...newArr);
      resources.forEach((item) => {
        Object.assign(item, {
          fileName: item.name,
          fileId: item.bizId || nanoid(20),
          fileUrl: item.url,
          status: FileStatus.Done
        });
      });
      setFileList(resources as any);

      setTaskDetail((task: NewTaskModel) => {
        return {
          ...task,
          resources
        };
      });
      message.success(t("attachment upload success"));
      return;
    }
    let newFile = {
      name: file.fileName,
      size: file.size,
      url: file.fileUrl,
      resourceId: nanoid(),
      bizId: file.fileId,
      bizType: file.bizType || TaskResourceBizType.FILE,
      resourceType: TaskResourcePermissionType.COMMON,
      fileType: file.fileType,
      creatorUserId: file?.creatorUserId
    };
    const resourceId = nanoid();

    const temp = {
      ...file,
      ...newFile,
      percent: 0,
      fileUrl: file.fileUrl,
      resourceId,
      status: FileStatus.Done
    };
    // 移除不必要的字段，否则网路请求会报错
    delete temp.icon;
    delete temp.taskInstance;

    const resources = taskDetail.resources;
    resources.push(temp);
    setFileList(resources);
    setTaskDetail((task: NewTaskModel) => {
      return {
        ...task,
        resources
      };
    });

    // message.success(t('attachment upload success'));
    // return { resourceId: resourceId };
  }
  const handleShareClick = useCallback(
    (data, taskId) => {
      const { teamUserInfo } = userData;
      const { ddAppId, teamId, realName } = teamUserInfo;
      const sharelink = {
        ext: "",
        icon:
          "http://storage.360buyimg.com/jd.jme.photo/message_icon_task2x.png?Expires=3757406611&AccessKey=93c0d2d5a6cf315c3d4c52c5f549a9a886b59f76&Signature=pTm0aXa1Azq0eea7K91GNDWDypo%3D",
        // source: 'joyWork',
        category: "joywork",
        title: t("share card title").replace("%s", realName),
        content: data.title,
        url: DeeplinkEvent.strify({
          appId: ddAppId,
          path: DeeplinkPathEnum.Task_Draw,
          mparam: {
            taskId: taskId,
            taskName: data.title,
            projectId: data.projectId ? data.projectId : "",
            from: "mobile",
            priorityType: data.priorityType,
            dueTag: data.endTime && dayjs(data.endTime).isBefore(dayjs()),
            endTime: data.endTime,
            startTime: data.startTime,
            content: data.content
          }
        })
      };
      const msg: ChatMessageBody = {
        type: ChatMessageType.TEMPLATE2,
        template: {
          nativeId: "share_link"
        },
        code: 0,
        data: [
          {
            sharelink: sharelink,
            type: 0
          }
        ]
      };
      const messageId = generateMessageId();
      imService.sendChatMessage(selectedSession?.["sessionId"] || "", messageId, msg);
      const [toUserId] = selectedSession?.sessionId.split(":") || [];
      shareScheduleAttachment({
        bizId: taskId,
        bizType: 1,
        shareRecipientDtos: [
          {
            recipientType: selectedSession.isGroup ? "2" : "1",
            recipientId: toUserId,
            recipientName: selectedSession.info.name,
            teamId: authInfo.teamUserInfo.teamId,
            app: authInfo.teamUserInfo.ddAppId
          }
        ]
      });
    },
    [
      userData,
      t,
      selectedSession,
      imService,
      authInfo.teamUserInfo.teamId,
      authInfo.teamUserInfo.ddAppId
    ]
  );

  const handleTaskReminChange = function (val: string[]) {
    if (val.length === 2 && val[0] === "0") {
      val.shift();
    }
    if (val.length >= 1 && val[val.length - 1] === "0") {
      setTaskDetail({
        ...taskDetail,
        remind: "0"
      });
      setRemindArr(["0"]);
    } else {
      setTaskDetail({
        ...taskDetail,
        remind: val.join(",")
      });
      setRemindArr([...val]);
    }
  };

  const addTask = useCallback(
    async (share = false) => {
      // 不允许跨租户、跨平台人员创建任务
      // 由于任务禁止选择外部人员 只需判断当前用户是否是跨租户、跨平台人员且在任务创建人或协同人中则不允许创建
      // owner executors currentEmployee
      const hasOuterExecutor = taskDetail.executors?.findIndex(
        (executor: WorkUserInfo) =>
          executor.app === currentEmployee.app &&
          executor.userId === currentEmployee.userId &&
          executor.teamId === currentEmployee.teamId
      );
      if (
        (hasOuterExecutor > -1 ||
          (taskDetail.owner.app === currentEmployee.app &&
            taskDetail.owner.userId === currentEmployee.userId &&
            taskDetail.owner.teamId === currentEmployee.teamId)) &&
        (currentEmployee.userType === "4" || currentEmployee.userType === "5")
      ) {
        return message.error(t("External users do not support using tasks"));
      }

      if (!taskDetail.title) {
        message.error(t("create task err title"));
        return;
      }
      if (!taskDetail.priorityType) {
        message.error(t("create task err priorityType"));
        return;
      }

      if (taskDetail.workStartTime && dayjs().isAfter(taskDetail.workStartTime)) {
        const confirm = await syncConfirm("是否创建一个过去时间的任务");
        if (!confirm) {
          return;
        }
      }

      setSubmitting(true);
      const [data, err]: any = await createTask({
        ...taskDetail,
        remark: (taskDetail.remark?.remark || "") as any
      });
      if (err) {
        message.error(err as string);
        if (err.includes("分组")) {
          fetchTaskGroupsList();
          bus.emit("task:leftSideTabsReset", data);
          taskGroupDeleted.current = true;
          setTaskDetail((prev) => {
            return { ...prev, taskGroupIds: [] };
          });
        }
        setSubmitting(false);
        return;
      }
      resetData();
      setSubmitting(false);
      if (selectedSession && share) {
        handleShareClick(taskDetail, data.taskId);
        return;
      }
      // await getTaskList();
      setTimeout(() => {
        bus.emit("task:refreshTaskTable", 0);
        if (taskGroupDeleted.current) {
          bus.emit("task:leftSideTabsReset", data);
        } else {
          bus.emit("task:refreshTaskTable", 0);
        }
        taskGroupDeleted.current = false;
      }, 0);
      return;
    },
    [activeKey, taskDetail, currentEmployee, resetData, selectedSession, t, handleShareClick]
  );

  const addTaskValidate = useCallback(
    (_e, share = false) => {
      function cancleAtt(status: boolean) {
        bus.off("cancle-attachment-upload", cancleAtt);
        if (status) {
          message.warning(t("attachment uploading"));
          return;
        } else {
          addTask(share);
        }
      }
      bus.on("cancle-attachment-upload", cancleAtt);
      bus.emit("close-modal-detail");
      return () => {
        bus.off("cancle-attachment-upload", cancleAtt);
      };
    },
    [addTask, t]
  );

  const addAndShare = function (_e: any) {
    addTaskValidate(_e, true);
  };

  const handleList = useCallback((data) => {
    const setData = data.map((item: any) => {
      return {
        ...item,
        isRemove: true
      };
    });

    return setData;
  }, []);

  const onSetup = () => {
    setMoreVisible(false);
  };
  const operators = useMemo(() => {
    if (taskDetail.executors.length > 3) {
      return taskDetail.executors.slice(0, 2);
    }
    return [...taskDetail.executors];
  }, [taskDetail.executors]);
  const subscribers = useMemo(() => {
    if (taskDetail.subscribers.length > 5) {
      return taskDetail.subscribers.slice(0, 4);
    }
    return [...taskDetail.subscribers];
  }, [taskDetail.subscribers]);

  const handleApproval = (e: boolean) => {
    setTaskDetail({ ...taskDetail, processAuditFlag: e === true ? 1 : 0 });
  };

  const createTaskgroup = () => {
    setIsModalVisible(true);
  };

  const DrawerFooter = (
    <div>
      {selectedSession && (
        <Button
          loading={submitting}
          type="primary"
          disabled={!taskDetail.title.trim()}
          onClick={addAndShare}
          clstag={isMessageModule ? "pageclick|keycount|Xtbg_Msg_SendToIM|MessTask" : undefined}
        >
          {t("create task and share")}
        </Button>
      )}
      <Button
        loading={submitting}
        clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_createtask_complete"
        type="primary"
        disabled={!taskDetail.title.trim()}
        onClick={addTaskValidate}
      >
        {t("confirm")}
      </Button>
      <Button onClick={closeDrawConfirm}>取 消</Button>
    </div>
  );

  if (!drawVisible) {
    return null;
  }
  return (
    <Drawer
      width="450"
      keyboard={false}
      className="work-create-draw work-edit-draw"
      title={
        <div className="detail-header">
          <div>{t("new task")}</div>
          <div className="header-btn-wrapper">
            <div className="action-close action-button app-region-none" onClick={closeDrawConfirm}>
              <IconFont type="iconapp_btn_file_cancel" />
            </div>
          </div>
        </div>
      }
      visible={true}
      destroyOnClose={true}
      maskClosable={true}
      footer={DrawerFooter}
      placement="right"
      onClose={closeDrawConfirm}
      closable={false}
    >
      <div className="detail-outer">
        <ScrollView ref={scrollRef} autoHide>
          <div className="detail-content">
            <div className="content-part-top">
              <div className="detail-content-item task-title-item">
                <div
                  className={`title-container ${
                    textareaTitleFocus ? "textarea-container-focus" : ""
                  }`}
                >
                  {/* <Input
                                        className="cursor-outline"
                                        placeholder={t('input task content')}
                                        value={taskDetail.title}
                                        onChange={(e) => handleInputChange(e, 'title')}
                                        maxLength={100}
                                    /> */}
                  <Input.TextArea
                    className="cursor-outline"
                    style={{ resize: "none" }}
                    autoSize={{ minRows: 1 }}
                    placeholder={t("input task content")}
                    value={taskDetail.title}
                    onChange={(e) => handleInputChange(e, "title")}
                    onFocus={() => setTextareaTitleFocus(true)}
                    onBlur={() => setTextareaTitleFocus(false)}
                    maxLength={100}
                  />
                  {/* {taskDetail.title && taskDetail.title.length > 30 && (
                    <p className="content-length">
                      <span>{taskDetail.title?.length || 0}</span>/100
                    </p>
                  )} */}
                  {/* <p className="content-length">
                                        <span>{taskDetail.title?.length || 0}</span>/100
                                    </p> */}
                </div>
              </div>
              <div className="detail-content-item task-textarea-item" style={{ margin: 0 }}>
                {/* <div className="label" style={{ alignSelf: "flex-start" }}>
                  任务描述
                </div> */}
                <div
                  className={`textarea-container ${
                    textareaContentFocus ? "textarea-container-focus" : ""
                  }`}
                >
                  <Input.TextArea
                    className="cursor-outline"
                    placeholder="请输入任务描述"
                    value={taskDetail.content || ""}
                    autoSize={{ minRows: 7 }}
                    onChange={(e) => handleInputChange(e, "content")}
                    onFocus={() => setTextareaContentFocus(true)}
                    onBlur={() => setTextareaContentFocus(false)}
                    maxLength={500}
                  />
                  {/* {taskDetail.content && taskDetail.content.length > 40 && (
                    <p className="content-length">
                      <span>{taskDetail.content?.length || 0}</span>/500
                    </p>
                  )} */}
                </div>
              </div>
              {/* <div className="detail-content-type">{t('members info')}</div> */}
              <div className="detail-content-item task-owner-item" style={{ marginTop: "16px" }}>
                <div className="label">
                  {/* <span>*</span> */}
                  {t("task user")}
                </div>
                <div className="owner-container owner-user">
                  <UserListMore
                    disable={taskDetail.owner}
                    list={[taskDetail.owner]}
                    maxLength={8}
                    notAvatar={true}
                    notTooltip={true}
                    addMemberCb={handleUpdateOwner}
                    title={taskDetail.title}
                    isOnClick={true}
                    taskUserRole={1}
                  />
                  {taskDetail.owner && (
                    <div
                      className="trans-owner"
                      onClick={handleUpdateOwner}
                      clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_createtask_transferowner"
                    >
                      <span style={{ whiteSpace: "pre" }}> 负责</span>
                    </div>
                  )}
                </div>
                <span className="work-line" />
                <div className="owner-container">
                  <UserStatusListPopover
                    popoverName="getTaskContent"
                    list={handleList(taskDetail.executors)}
                    onRemove={(data: any[]) => handledelMember(MemberKeys.executors, data)}
                    userPopover="task"
                    userPopoverText="colaborator"
                    disable={false}
                    mode="create"
                  >
                    <div className="owner-container-name">
                      {operators?.map((l, index) => (
                        <UserItem
                          key={"executor-" + index}
                          item={l}
                          notAvatar={true}
                          notTooltip={true}
                        />
                      ))}
                    </div>
                  </UserStatusListPopover>
                  <UserListMore
                    list={handleList(taskDetail.executors)}
                    maxLength={3}
                    hasWeightSet={true}
                    notAvatar={true}
                    notTooltip={true}
                    title={taskDetail.title}
                    addMemberDisable={taskDetail.executors.length >= 200}
                    handleAddTaskMembers={(data: any[]) =>
                      handleAddTaskMembers(MemberKeys.executors, data)
                    }
                    isGroup={selectedSession?.["isGroup"]}
                    sessionId={selectedSession?.["sessionId"]}
                    userPopover="task"
                    userPopoverText="colaborator"
                    isOnClick={true}
                    disable={false}
                    showUserItem={false}
                    mode="create"
                    taskUserRole={2}
                  />
                </div>
              </div>
              <div
                className="detail-content-item task-subscribers-item"
                style={{ marginTop: "16px" }}
              >
                <div className="label">{t("task subscribers")}</div>
                <div className="subscribers-container">
                  <UserStatusListPopover
                    popoverName="getTaskContent"
                    list={handleList(taskDetail.subscribers)}
                    onRemove={(data: any[]) => handledelMember(MemberKeys.subscribers, data)}
                    userPopover="task"
                    userPopoverText="subscribers"
                    disable={false}
                    mode="create"
                  >
                    <div className="subscribers-container-name">
                      {subscribers?.map((l, index) => (
                        <UserItem
                          key={"subscribers-" + index}
                          item={l}
                          notAvatar={true}
                          notTooltip={true}
                        />
                      ))}
                    </div>
                  </UserStatusListPopover>
                  <UserListMore
                    list={handleList(taskDetail.subscribers)}
                    maxLength={4}
                    hasWeightSet={false}
                    notAvatar={true}
                    title={taskDetail.title}
                    addMemberDisable={taskDetail.subscribers.length >= 200}
                    handleAddTaskMembers={(data: any[]) =>
                      handleAddTaskMembers(MemberKeys.subscribers, data)
                    }
                    onRemove={(data: any[]) => handledelMember(MemberKeys.subscribers, data)}
                    isGroup={selectedSession?.["isGroup"]}
                    sessionId={selectedSession?.["sessionId"]}
                    userPopover="task"
                    userPopoverText="subscribers"
                    isOnClick={true}
                    disable={false}
                    showUserItem={false}
                    mode="create"
                    taskUserRole={4}
                  />
                </div>
              </div>
            </div>

            <div className="content-part-other">
              <div
                className="detail-content-item task-timerange-item common-single-item task-ontime-item"
                style={{ margin: "16px 0" }}
              >
                <div className="label">{t("work time")}</div>
                <div className="timerange-container">
                  <div className="time-button time-button-star">
                    <DatePicker
                      onVisibleChange={onVisibleChange}
                      time={taskDetail.workStartTime || null}
                      onChange={(time: Dayjs | null) => handleTimeChange(time)}
                      placeholder="开始时间"
                      configOfPopover={{ getPopupContainer: undefined }} // 处理：Popover 组件错位
                      isChangeHeaderVisible={true}
                    />
                  </div>

                  <div className="button-split" />
                  <div className="time-button time-button-end">
                    <DatePicker
                      onVisibleChange={onVisibleChange}
                      time={taskDetail.workStopTime || null}
                      onChange={(time: Dayjs | null) => handleTimeChange(time, false)}
                      placeholder="截止时间"
                      configOfPopover={{ getPopupContainer: undefined }}
                      isChangeHeaderVisible={true}
                    />
                  </div>
                </div>
              </div>
              <div className="detail-content-item task-types-item">
                <div className="label">重要程度</div>
                <TypeSelect
                  priority={taskDetail.priorityType}
                  onRadioChange={handlePriorityChange}
                  type="radio"
                  isCreate={true}
                />
              </div>
              <div
                className="detail-content-item task-remind-item common-single-item"
                style={{ display: taskDetail.workStopTime ? "" : "none" }}
              >
                <div className="label">逾期提醒</div>
                <Select
                  disabled={!taskDetail.endTime || taskDetail.endTime === -1}
                  mode="multiple"
                  allowClear={false}
                  size="small"
                  showArrow={false}
                  showSearch={false}
                  value={remindArr}
                  placeholder="请选择提醒时间"
                  className="timerange-container"
                  onChange={handleTaskReminChange}
                >
                  {remindList.map((item: any) => {
                    return (
                      <Option
                        key={item.value}
                        value={item.value}
                        style={{
                          display:
                            item.value === "-5" || item.value === "-10" || item.value === "-15"
                              ? "none"
                              : "flex"
                        }}
                      >
                        {item.label}
                      </Option>
                    );
                  })}
                </Select>
              </div>
              {/* <div className="detail-content-item task-textarea-item">
                <div className="label" style={{ alignSelf: "flex-start" }}>
                  任务描述
                </div>
                <div
                  className={`textarea-container ${
                    textareaContentFocus ? "textarea-container-focus" : ""
                  }`}
                >
                  <Input.TextArea
                    className={`cursor-outline ${
                      taskDetail.content && taskDetail.content.length > 40
                        ? "padding-bottom-20"
                        : ""
                    }`}
                    placeholder={t("add description")}
                    autoSize
                    defaultValue={taskDetail.content || ""}
                    onChange={(e) => handleInputChange(e, "content")}
                    onFocus={() => setTextareaContentFocus(true)}
                    onBlur={() => setTextareaContentFocus(false)}
                    maxLength={500}
                  />
                  {taskDetail.content && taskDetail.content.length > 40 && (
                    <p className="content-length">
                      <span>{taskDetail.content?.length || 0}</span>/500
                    </p>
                  )}
                </div>
              </div> */}
            </div>
            {moreVisible && (
              <div
                className="setup"
                clstag="pageclick|keycount|xtbg_add_task_new_create_1687230342038|6"
                onClick={(e) => {
                  e.stopPropagation();
                  onSetup();
                }}
              >
                更多设置
              </div>
            )}

            {!moreVisible && (
              <div className="detail-content-item task-group-item">
                <div className="label">任务分组</div>
                <Select
                  className="timerange-container"
                  clstag="pageclick|keycount|xtbg_add_task_new_create_1687230342038|7"
                  mode="multiple"
                  onChange={(e) => handleInputChange(e, "taskGroupIds", true)}
                  onDropdownVisibleChange={() => {
                    if (!taskGroupList.length) {
                      fetchTaskGroupsList();
                    }
                  }}
                  showSearch={false}
                  showArrow={false}
                  allowClear={false}
                  placeholder="待分组"
                  notFoundContent="暂无分组"
                  size="small"
                  bordered={false}
                  value={taskDetail.taskGroupIds}
                  dropdownClassName="create-taskgroup"
                  dropdownRender={(menu) => (
                    <>
                      {menu}
                      <span className="create-taskgroup-btn" onClick={() => createTaskgroup()}>
                        +新建任务组
                      </span>
                    </>
                  )}
                >
                  {(taskGroupList || [])
                    .filter((v) => v.groupStatus !== 2)
                    .map((v) => (
                      <Option key={v.groupId} value={v.groupId}>
                        {v.groupName}
                      </Option>
                    ))}
                </Select>
              </div>
            )}

            {!moreVisible && (
              <div
                className="detail-content-item task-textarea-item task-mynote-item"
                style={{
                  alignItems: "initial"
                }}
              >
                <div className="label">我的备注</div>
                <div className="textarea-container" style={{ margin: 0, border: "none" }}>
                  <Input.TextArea
                    className="cursor-outline"
                    placeholder="请输入(仅自己可见)"
                    style={{ padding: "4px 0" }}
                    autoSize
                    value={taskDetail.remark.remark}
                    onChange={(e) => handleInputChange(e, "remark")}
                    maxLength={500}
                  />
                </div>
              </div>
            )}
            <div style={{ visibility: moreVisible ? "hidden" : "inherit" }}>
              <AttachmentItem
                disabled={false}
                mode="create"
                task={true}
                businessForm={BusinessForm.TASK}
                uploaderProxy={true}
                multiple={true}
                fileList={handleList(fileList)}
                onAttachmentRemove={onAttachmentRemove}
                onAttachmentUploadFinish={onAttachmentUploadFinish}
                uploadControlName="task-create-upload-panel"
              />
            </div>

            <div
              className="detail-content-item task-approval-item"
              style={{ visibility: moreVisible ? "hidden" : "inherit" }}
            >
              <div className="label">审批设置</div>
              <Switch
                onChange={(e) => {
                  handleApproval(e);
                }}
              />
              <Tooltip title={t("Approval settings tip")}>
                <IconFont type="iconic_app_add_help" />
              </Tooltip>
            </div>
            {/* <div className="content-part-other">
              <div className="detail-content-item task-textarea-item task-mynote-item">
                <Collapse
                  defaultActiveKey={[0]}
                  bordered={false}
                  expandIconPosition="right"
                  expandIcon={({ isActive }) => (
                    <IconFont
                      type="iconlog_enter"
                      className="icon-more"
                      rotate={isActive ? 270 : 90}
                    />
                  )}
                >
                  <Panel
                    header={
                      <div className="label" style={{ alignSelf: "flex-start" }}>
                        <b>{t("my note")}</b>
                        <em>(仅您自己可见)</em>
                      </div>
                    }
                    key={0}
                  >
                    <div
                      className={`textarea-container ${
                        textareaRemarkFocus ? "textarea-container-focus" : ""
                      }`}
                    >
                      <Input.TextArea
                        className={`cursor-outline ${
                          taskDetail.remark?.remark && taskDetail.remark.remark.length > 40
                            ? "padding-bottom-20"
                            : ""
                        }`}
                        placeholder={t("add remark content")}
                        autoSize
                        value={taskDetail.remark.remark}
                        onChange={(e) => handleInputChange(e, "remark")}
                        onFocus={() => setTextareaRemarkFocus(true)}
                        onBlur={() => setTextareaRemarkFocus(false)}
                        maxLength={500}
                      />
                      {taskDetail.remark?.remark && taskDetail.remark.remark.length > 40 && (
                        <p className="content-length">
                          <span>{taskDetail.remark?.remark?.length || 0}</span>
                          /500
                        </p>
                      )}
                    </div>
                  </Panel>
                </Collapse>
              </div>
            </div> */}
          </div>
        </ScrollView>
        {isModalVisible && (
          <TaskGroupModal userData={userData} setIsModalVisible={setIsModalVisible} />
        )}
      </div>
    </Drawer>
  );
}
function mapStateToProps({ user, work, chat }: any) {
  return {
    userData: user.userData.user,
    isMessageModule: chat.isMessageModule,
    taskGroupList: work.taskGroupList,
    groupId: work.groupId,
    activeKey: work.activeKey,
    currentEmployee: chat.currentEmployee || {}
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    fetchTaskGroupsList() {
      return dispatch({
        type: "work/queryTaskGroupsList"
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateTaskDraw);
